/** Réglages du fond Oiseau (voir ../reglages.js pour la description des types). */
export const REGLAGES = {
    vitesse: {
        type: "nombre", libelle: "Vitesse", min: 0.5, max: 3, pas: 0.1, defaut: 1, unite: "×",
        aide: "×1 est la vitesse d'origine.",
    },
    ouverture: {
        type: "nombre", libelle: "Ouverture des tuyaux", min: 32, max: 64, pas: 2, defaut: 44, unite: "px",
        aide: "Passage entre le tuyau du haut et celui du bas. L'oiseau passe toujours, même dans les plus serrés.",
    },
    taille: {
        type: "nombre", libelle: "Taille de l'oiseau (image de la galerie)", min: 16, max: 60, pas: 2, defaut: 28, unite: "px",
        aide: "Hauteur de l'image qui remplace l'oiseau. Sans effet avec l'oiseau d'origine.",
    },
    ambiance: {
        type: "choix", libelle: "Ambiance", defaut: "jour",
        options: [
            {valeur: "jour", libelle: "Jour"},
            {valeur: "soir", libelle: "Soir"},
            {valeur: "nuit", libelle: "Nuit"},
            {valeur: "auto", libelle: "Automatique (selon les horaires du magasin)"},
        ],
        aide: "Automatique : jour, crépuscule puis nuit selon les heures réglées dans « Horaires de l'ambiance automatique » (carte Fond du bandeau).",
    },
};
